import styled, { css } from "styled-components";

// styles
const HeaderStyles = styled.header`
    // background: rgba(255, 255, 255, 0.5);
    border-bottom: 1px solid ${({ theme }) => theme.borderColor2};
    position: relative;
    z-index: 9;
    .header {
        // padding-top: 15px;
        // padding-bottom: 15px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .logo,
    .right-sec {
        ${({ theme }) => theme && css`
            @media screen and (min-width: ${theme.responsiveBreakpoints.min_lg}) {
                width: 250px;
            }
        `}
    }

    .logo {
        // font-family: 'Playfair Display', serif;
        // font-size: 43px;
        // line-height: 37px;
        // margin-bottom: 3px !important;
        // color: #333;
        img {
            width: 50px;
        }
        ${({ theme }) => theme && css`
            @media screen and (min-width: ${theme.responsiveBreakpoints.min_lg}) {
                img {
                    width: 60px;
                }       
            }
        `}
    }
    // responsive
    .menu,
    .right-sec {
        ${({ theme }) => theme && css`
            @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
                width: 110px;
            }
        `}
    }

    .right-sec {
        .item {
            &:not(:last-child) {
                margin-right: 12px;
            }

            &.cart {
                
            }
        }
    }

    // menu-inner
    ${({ theme }) => theme && css`
        @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
            padding-left: 0;
            padding-right: 0;
            .logo {
                order: 1;
                flex: 1;
                text-align: center;
                padding: 0 5px;
            }
            .menu {
                order: 0;
                flex: initial;
            }
            .right-sec {
                order: 2;
                flex: initial;
            }
        }
    `}
`

const HeaderMenuStyles = styled.div`
    .overlay {
        &.mobile-menu-active {
            height: 100%;
            width: 100%;
            position: fixed;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.4)
        }
    }
    .main-sec {
        position: relative;
        z-index: 9;
    }

    .menu-container {
        ${({ theme }) => theme && css`
            @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
                padding-left: 10px;
                padding-right: 10px;
            }
        `}


        .menu-item {
            position: relative;
            ${({ theme }) => theme && css`
                @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
                    .menu-link {
                        width: 100%
                    }
                }
            `}

            .btn {
                width: 30px;
                height: 30px;
                padding: 0;
                background: transparent;
                ${({ theme }) => theme && css`
                    @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
                        background: #dfdfdf;
                    }
                `}
                ${({ theme }) => theme && css`
                    @media screen and (min-width: ${theme.responsiveBreakpoints.min_lg}) {
                        margin-right: -8px;
                    }
                `}
            }
        }

        .menu-link {
            color: ${({ theme }) => theme.textBlackMain};
            transition: .2s;
            &:hover {
                color: ${({ theme }) => theme.textBlackHover};
            }
        }

        .menu-item {
            &:hover {
                > .menu-link {
                    color: ${({ theme }) => theme.textBlackHover};
                }
            }
        }

        .sub-menu {
            background: #fff;
            border: 1px solid ${({ theme }) => theme.borderColor1};
            padding: 12px 0;
            transition: .2s;
            z-index: -1;

            ${({ theme }) => theme && css`
                @media screen and (min-width: ${theme.responsiveBreakpoints.min_lg}) {
                    opacity: 0;
                    visibility: hidden;
                    width: 200px;
                    position: absolute;
                    top: -1px;
                    left: calc(100% - 0px);
                }
            `}

            ${({ theme }) => theme && css`
                @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
                    display: none;
                }
            `}

            .menu-link {
                padding-right: 8px;
                padding-left: 18px;
                padding-top: 7px;
                padding-bottom: 7px;
                transition: .3s;
                &:hover {
                    background-color: ${({ theme }) => theme.subMenuHoverBgColor};
                }
            }
            .menu-item {
                &:hover,
                &.active {
                    > .menu-link {
                        background-color: ${({ theme }) => theme.subMenuHoverBgColor};
                    }
                }
            }
        }

        // handling visibility
        .menu-item {
            &.active {
                > .sub-menu {
                    z-index: 1;
                    ${({ theme }) => theme && css`
                        @media screen and (min-width: ${theme.responsiveBreakpoints.min_lg}) {
                            opacity: 1;
                            visibility: visible;
                        }
                    `}
                    ${({ theme }) => theme && css`
                        @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
                            display: block;
                        }
                    `}
                }
            }
        }

        > .menu-item {
            ${({ theme }) => theme && css`
                @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
                    &:not(:last-child) {
                        margin-bottom: 15px;                    
                    }
                }
            `}
            .menu-item {
                &:hover {
                    > .sub-menu {
                        ${({ theme }) => theme && css`
                            @media screen and (min-width: ${theme.responsiveBreakpoints.min_lg}) {
                                opacity: 1;
                                visibility: visible;
                            }
                        `}
                    }
                }
                &.active {
                    > .sub-menu {
                        ${({ theme }) => theme && css`
                            @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
                                display: block;
                            }
                        `}
                    }
                }
            }
        }

        > .menu-item {
            &:not(:last-child) {
                ${({ theme }) => theme && css`
                    @media screen and (min-width: ${theme.responsiveBreakpoints.min_lg}) {
                        margin-right: 25px;                    
                    }
                `}
            }
            > .menu-link {
                letter-spacing: 1px;
                font-size: 16px;
            }
            > .sub-menu {
                left: 0;
                top: -5%;
                // &::after {
                //     content: '';
                //     position: absolute;
                //     top: -20px;
                //     left: 17px;
                //     width: 0;
                //     height: 0;
                //     border-color: transparent transparent #fff transparent;
                //     border-width: 10px;
                //     border-style: solid;
                // }
            }
            &.active {
                > .sub-menu {
                    top: calc(100% + 1px);
                }
            }
        }
    }

    // responsive
    ${({ theme }) => theme && css`
        @media screen and (max-width: ${theme.responsiveBreakpoints.max_lg}) {
            .menu-inner {
                position: fixed;
                top: 0;
                left: -100%;
                height: 100%;
                width: 300px;
                background: #fff;
                z-index: 99;
                transition: .4s;
                padding: 20px 15px;
                overflow: auto;
                &.mobile-menu-active {
                    left: 0;
                }
            }
        }
    `}
`

const HeaderSearchContent = styled.div`
    .search-item {
        >.si-inner {
            border-bottom: 1px solid ${({ theme }) => theme.borderColor2};
            padding-top: 5px;
            padding-bottom: 5px;
            transition: .3s;
            &:hover {
                color: ${({ theme }) => theme.colorPrimary};   
            }
        }
        .text-sec {
            padding-left: 15px;
        }
    }
`

export {
    HeaderStyles,
    HeaderMenuStyles,
    HeaderSearchContent
}